module.exports = require("@pb/kit-util-is-test-environment");